import * as R from 'ramda'

import Faq from './faq'
import s from './styles.module.css'
import { AnalyticsSection } from 'containers/analytics'
import { useContext } from 'react'
import CmsPageContext from 'contexts/cms-page-context'

const FaqsExperiment = ({ fields }) => {
  const { locationDetails } = useContext(CmsPageContext)

  if (!fields) return null

  const { header } = fields

  const faqs = R.uniqBy(
    R.prop('id'),
    R.map(
      ({ sys: { id }, fields: { question, answer } }) => ({
        id,
        question,
        answer,
      }),
      fields.primaryItems
    )
  )

  return (
    <AnalyticsSection name="FAQ">
      <section className={s.container}>
        <div className={s.content}>
          <div className={s.header}>{header}</div>
          <ul className={s.faqs}>
            {R.map(faq => {
              return (
                <li className={s.faq} key={faq.id}>
                  <Faq faq={faq} locationDetails={locationDetails} />
                </li>
              )
            }, faqs)}
          </ul>
        </div>
      </section>
    </AnalyticsSection>
  )
}
export default FaqsExperiment
